import { render } from "./TailwindIcon.vue?vue&type=template&id=2d00d810&scoped=true"
import script from "./TailwindIcon.vue?vue&type=script&lang=js"
export * from "./TailwindIcon.vue?vue&type=script&lang=js"

import "./TailwindIcon.vue?vue&type=style&index=0&id=2d00d810&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d00d810"]])

export default __exports__